<ion-header>
    <ion-toolbar>
        <div class="btn-back-menu" (click)="onBackMenu()">
            <ion-icon class="no-padding" name="arrow-back"></ion-icon>
            <button ion-button clear color="light" no-padding>
                <strong style="color:black !important" class="margin-sides">{{ 'GLOBAL_BACK' | translate
                    }}</strong>
            </button>
        </div>
        <ion-title>{{ 'SETTINGS' | translate }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid>
        <ion-row>
            <ion-col col-2>
                <img src="../../assets/imgs/claphands.svg">
            </ion-col>
            <ion-col col-8>
                <ion-label>{{ 'APPLAUSE_SOUND_CONFIGURE' | translate }}</ion-label>
            </ion-col>
            <ion-col col-2>
                <ion-checkbox [(ngModel)]="option.applause"></ion-checkbox>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col col-2>
                <ion-icon name="pause"></ion-icon>
            </ion-col>
            <ion-col col-8>
                <ion-label>{{ 'AUTO_PAUSE_CONFIGURE' | translate}}</ion-label>
            </ion-col>
            <ion-col col-2>
                <ion-checkbox [(ngModel)]="option.autoPause"></ion-checkbox>
            </ion-col>
        </ion-row>

        <ion-row style="margin-top: 8px;">
            <ion-col col-2>
                <ion-icon name="aperture"></ion-icon>
            </ion-col>
            <ion-col col-8>
                <ion-label>{{ 'REALTIME_PLACES_CONFIGURE' | translate}}</ion-label>
            </ion-col>
            <ion-col col-2>
                <ion-checkbox [(ngModel)]="option.placement"></ion-checkbox>
            </ion-col>
        </ion-row>

        <ion-row style="margin-top: 8px;">
            <ion-col col-2>
                <ion-icon name="map"></ion-icon>
            </ion-col>
            <ion-col col-8>
                <ion-label>Google Maps</ion-label>
            </ion-col>
            <ion-col col-2>
                <ion-checkbox [(ngModel)]="option.google"></ion-checkbox>
            </ion-col>
        </ion-row>
    </ion-grid>

    <ion-item>
        <button ion-button (click)="onSave()">
            {{ 'GLOBAL_SAVE' | translate }}
        </button>
    </ion-item>


    <!-- 
    <ion-list>
        <ion-list-header>
            <ion-title>{{ 'SETTINGS' | translate }}</ion-title>
        </ion-list-header>
        <ion-item>
            <ion-icon name="pause"></ion-icon>
            <ion-label style="min-width: 70%;">{{ 'APPLAUSE_SOUND_CONFIGURE' | translate }}</ion-label>
            <ion-checkbox [(ngModel)]="option.applause">
            </ion-checkbox>
        </ion-item>
        <ion-item>
            <ion-icon ios="ios-hand" md="md-hand"></ion-icon>
            <ion-label style="min-width: 70%;">{{ 'AUTO_PAUSE_CONFIGURE' | translate}}</ion-label>
            <ion-checkbox [(ngModel)]="option.autoPause">
            </ion-checkbox>
        </ion-item>

        <ion-item>
            <button ion-button (click)="onSave()">
                Save
            </button>
        </ion-item>
    </ion-list> -->

</ion-content>